import { Grid } from "@mui/material";

type FieldArrayNoContentMessageProps = {
  message?: string;
};

export const FieldArrayNoContentMessage = ({
  message = "No data sets available.",
}: FieldArrayNoContentMessageProps) => {
  return (
    <Grid container item>
      <Grid container item xs={12}>
        {message}
      </Grid>
    </Grid>
  );
};
